module.exports = __webpack_public_path__ + "img/finance-light.1ce26f97.png";